import { gql } from '@apollo/client';

export default gql`
  query userProfileHeader {
    user {
      email
      name
      surname
      darkMode
      locale
      adminRole
    }
    space {
      id
      name
      adminRole
      role
      
    }
  }
`;
